/** User IDs allowed to configure return-to-waiting-room on experience sessions. */
export const RETURN_TO_WAITING_ROOM_EXPERIENCE_USER_IDS = new Set<number>([
  153,
]);

export function canUserConfigureReturnToWaitingRoom(
  userId: number | null | undefined
): boolean {
  return (
    typeof userId === 'number' &&
    RETURN_TO_WAITING_ROOM_EXPERIENCE_USER_IDS.has(userId)
  );
}
